import * as Yup from 'yup'

import { emailRegex } from '@/util'

export const validationSchema = Yup.object({
  email: Yup.string()
    .email('Invalid email address')
    .required('Required')
    .matches(emailRegex, 'Invalid email address')
    .nullable(),
})

export const initialValues = { email: '' }
